<div class="row" *ngIf="!isLoading">
  <div class="col-md-6">
    <div class="form-group">
      <label class="control-label">Previous Categories</label>
      <ul class="list-group">
        @for ( category of localProfile.PreviousCategories; track category ) {
          <li class="list-group-item">{{category}}</li>
        }
      </ul>
    </div>
  </div>
  <div class="col-md-6">
    <form [formGroup]="form">
      <div class="form-group">
        <label class="form-label" for="categories">Categories</label>
        <ng-select [formValidation]="form.controls.categories" id="categories" [items]="categories" [clearable]="true"
          [multiple]="true" [closeOnSelect]="false" bindLabel="FullName" bindValue="BusinessCitationProviderCategoryId"
          [virtualScroll]="true" formControlName="categories" placeholder="Categories"></ng-select>
        <div *ngIf="partnerRequiresSso" class="mt-2">
          <button (click)="editOnPartnerSite()" [disabled]="isLoading" class="btn btn-primary">
            <i class="fas fa-sign-in-alt"></i>{{ partnerSsoLabel }}</button>
          <button (click)="refresh()" [disabled]="isLoading" class="btn btn-primary">
            <i class="fas fa-sync"></i> Refresh
          </button>
        </div>
      </div>
    </form>
  </div>
</div>